import { createFeatureAreaResolver } from '@cast/infrastructure-monitoring';

export const getFeatureArea = createFeatureAreaResolver({
  clusters: (segments) => (segments.length > 1 ? 'dashboard' : 'clusters'),
});
